import { useCallback } from 'react';

import { useSearchActions, useSearchState } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<
	{
		hideButton: boolean;
	},
	{
		clearRefine: () => void;
	}
>;

export function useClearTopicsFilter(): Result {
	const state = useSearchState();
	const actions = useSearchActions();

	return {
		data: {
			hideButton: state.topics.length === 0,
		},
		actions: {
			clearRefine: useCallback(() => {
				actions.clearTopics();
			}, [actions]),
		},
	};
}
